import _ from 'lodash';
import { initDycolor, CreativePreviewScaled, LeadFormPreview, creativeDefaults } from '~';
import { mapState } from 'vuex';
import { GOAL_LEAD_GENERATION } from '@/util/constants';

initDycolor('post', require(`${process.env.DYCOLOR_REQUIRE}./Creative.scss`)); // eslint-disable-line

export default {
  props: {
    creative: Object,
    facebookPage: Object,
    disabledButtons: {
      type: Boolean,
      default: false,
    },
    mobilePreview: {
      type: Boolean,
      default: false,
    },
    enableFormPreview: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    'creative-preview-scaled': CreativePreviewScaled,
    'lead-form-preview': LeadFormPreview,
  },
  computed: {
    ...mapState('campaign', { campaign: 'current' }),
    ...mapState('genericConfig', ['config']),
    isGoalIsLeadGeneration() {
      return this.campaign.campaign_rule.goal_type === GOAL_LEAD_GENERATION;
    },
    firstThumbnail() {
      const leadPhoto = _.get(this.creative, 'lead_photo.thumbnail', null);
      if (leadPhoto) {
        return leadPhoto;
      }

      const firstMedia = _.get(this.creative, 'media[0].file.thumbnail', null);
      if (firstMedia) {
        return firstMedia;
      }

      return creativeDefaults.image;
    },
    defaultLeadConfig() {
      return _.get(this.config, `goal_types.${GOAL_LEAD_GENERATION}.config`, null);
    },
    customQuestion() {
      const question = _.get(this.creative, 'lead_config.default_question', null);

      if (question) {
        return question;
      }
      return this.defaultLeadConfig.default_question;
    },
    isInCreativeView() {
      return this.$router.currentRoute.name === 'creative';
    },
  },
  methods: {
    showLeadModal(creativeId) {
      this.$refs[`lead-form-modal-${creativeId}`].show();
    },
    openItem() {
      this.$router.push({
        name: 'creative',
        params: { id: this.creative.id },
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/rabbit/campaign-creatives/creative/Creative.js